import axios from 'axios';
import types from './adminDashboardTypes';

import { toastr } from "react-redux-toastr";

import { BASE_API, USER_TOKEN } from '../../../../config/consts';
import { errors2String } from '../../../../helpers/utils';

const URL = `${BASE_API}/dashboard/admin`;


/**
 * Função que serve para trazer todos os estados cadastradas
 * @returns {Object} Evento com a Promise da requisição. o redux-promise irá
 * tratar de resolver a Promise antes de atualizar o reducer
 */
export const getList = () => {
    return (dispatch) => {
        axios.get(URL, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        }).then((response) => {
            dispatch({
                type: types.ADMIN_DASHBOARD_FETCHED,
                payload: response
            });
        }).catch((err) => {
            try {
                const errors = errors2String(err.response.data.content.errors);
                dispatch({ type: 'ERROR_ADMIN_DASHBOARD_FECHED'});
                toastr.error('Erro!', errors);
            } catch (error) {
                dispatch({ type: 'ERROR_ADMIN_DASHBOARD_FECHED'});
                toastr.error('Erro!', 'Erro no servidor, favor verificar a politica de CORS');
                console.log(err);
            }
        });
    }
}